import { useContext, useEffect, useState } from "react";
import { RouteContext } from "../../contexts/RoutesContext";
import { API_VerifyEmailAddress, EmailAddressVerificationStatus, Status } from "../../apis/ApiEmailVerification";
import { useSearchParams } from "react-router-dom";
import { Card } from "../components/Shared/Card";
import { Colour } from "../Variables";
import { AppContext } from "../../contexts/AppContext";

export function EmailVerificationPage() {
    const [status, setStatus] = useState<number>(null);
    const [email, setEmail] = useState<string>('');
    const [queryParameters] = useSearchParams();
    const routeContext = useContext(RouteContext);
    const app = useContext(AppContext);

    let code: string = queryParameters.get("c");

    const checkVerification = async () => {
        var res: EmailAddressVerificationStatus = await API_VerifyEmailAddress(code);

        if (res !== null) {
            setStatus(res.Status);
            setEmail(res.EmailAddress);
        }
        else {
            setStatus(Status.Unknown);
        }
    }

    useEffect(() => {
        routeContext.setRoutes([{ name: "Email verification", route: null }]);
        if((code?.length ?? 0) > 0)
        {
            checkVerification();
        }
        else
        {
            setStatus(Status.InvalidCode);
        }
    }, []);

    return (
        <Card headerClasses="" title="Email verification" headerTheme={Colour.Secondary}>
            {status === Status.Verified &&
                <div className="p-2 ms-4">
                    You have successfully validated your email address: {email}
                </div>}
            {status === Status.InvalidCode &&
                <div className="p-2 ms-4">
                    Invalid verification code.
                </div>}
            {status === Status.Unknown &&
                <div className="p-2 ms-4">
                    <p>There was an error verifing your email, please try again.</p>
                    <p>If the error persists, contact support at <a href={`mailto:${app.baseFeatures && app.baseFeatures.AdminEmailAddress}`}>{app.baseFeatures && app.baseFeatures.AdminEmailAddress}</a></p>
                </div>}
        </Card>
    );
}